var _defs, _circle, _rect, _rect2, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVinylRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 600,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m300 300 -300 -50 350 350 -50 -300 300 -50 -250 -250 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "circ"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 287,
    cx: 300,
    cy: 300
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g1",
    cx: "50%",
    cy: "50%",
    r: "50%",
    fx: "15%",
    fy: "15%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000",
    offset: "100%",
    opacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g2",
    cx: "50%",
    cy: "50%",
    r: "50%",
    fx: "85%",
    fy: "85%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000",
    offset: "100%",
    opacity: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 290,
    cx: 300,
    cy: 300,
    fill: "#000",
    stroke: "#000",
    strokeWidth: 6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "url(#g1)",
    clipPath: "url(#circ)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 300,
    width: 300,
    height: 300,
    fill: "url(#g2)",
    clipPath: "url(#circ)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 150,
    cx: 300,
    cy: 300,
    fill: "#000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 100,
    cx: 300,
    cy: 300,
    fill: "#333",
    stroke: "#444",
    strokeWidth: 5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 80,
    cx: 300,
    cy: 300,
    fill: "#eee"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 8,
    cx: 300,
    cy: 300,
    fill: "#000"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 90,
    cx: 300,
    cy: 300,
    fill: "none",
    stroke: "#ccc",
    strokeWidth: 5,
    clipPath: "url(#clip)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVinylRecord);
export default __webpack_public_path__ + "static/media/vinyl-record.d22644c184ba1aabeefb7af130864a06.svg";
export { ForwardRef as ReactComponent };